import type { Schema } from 'firebase/ai';

// Same lazy dynamic-import pattern as `clinical-report.schema.ts` -- `firebase/ai` never enters
// the bundle for a session that doesn't open the AI report drawer.
export async function buildClinicalTemplateSchema(): Promise<Schema> {
  const { Schema } = await import('firebase/ai');

  return Schema.object({
    properties: {
      texto: Schema.string(),
      datosNoEncontrados: Schema.array({ items: Schema.string() }),
      inconsistencias: Schema.array({
        items: Schema.object({
          properties: {
            descripcion: Schema.string(),
            fragmentos: Schema.array({ items: Schema.string() }),
          },
          optionalProperties: ['fragmentos'],
        }),
      }),
    },
    optionalProperties: ['datosNoEncontrados', 'inconsistencias'],
  });
}
